export default {
  actionSelection: {
    title: 'Velg handling',
    actions: [
      {
        id: 'end_date',
        title: 'Avslutt leieforhold',
        description: 'Angi en dato hvor leieforholdet vil ta slutt.',
        disclaimer: 'Dette vil avslutte leieforholdet og abonnementet.',
        severity: 'warning',
      },
      {
        id: 'terminate_only',
        title: 'Endre abonnement',
        description: 'Oppgrader, nedgrader, eller avslutt abonnement.',
        disclaimer: 'Oppgradering vil skje umidelbart, nedgradering/avslutting vil foregå ved neste fakturering.',
        severity: 'warning',
      },
      {
        id: 'delete_tenancy',
        title: 'Slett leieforhold',
        description: 'Vil du slette leieforholdet? ',
        disclaimer: 'Denne handlingen kan ikke reverseres. Gjør kun dette ved duplikate leieforhold.',
        severity: 'danger',
      },
    ],
  },
  flows: {
    end_date: [
      {
        type: 'reason_selection',
        title: 'Hvorfor vil du avslutte leieforholdet?',
        subtitle: 'Din tilbakemelding vil hjelpe oss å forbedre produktet.',
        reasons: [
          { value: 'tenant_resign', label: 'Leietaker har avsluttet leieforholdet' },
          { value: 'lease_expired', label: 'Leieavtalen er over' },
          { value: 'tenant_moved_out', label: 'Leietaker har flyttet ut' },
          { value: 'property_sold', label: 'Eiendom er solgt' },
          { value: 'tenant_contract_breach', label: 'Leietaker har brutt leiekontrakt' },
          { value: 'mutual_agreement', label: 'Enighet om tidlig avbrytelse av leieforhold' },
          { value: 'property_renovations', label: 'Eiendom krever stor oppussing' },
          { value: 'landlord_for_personal_use', label: 'Utleier trenger eiendom for personlig bruk' },
          { value: 'rent_not_paid', label: 'Leie ikke betalt' },
          { value: 'other', label: 'Annen grunn', hasTextarea: true },
        ],
      },
      {
        type: 'date_selection',
        title: 'Velg sluttdato for leieforholdet',
        subtitle: 'Velg datoen når leieforholdet skal avsluttes.',
        field: 'selectedTenancyEndDate',
        validation: { required: true, minDate: 'today' },
        helper: 'Datoen kan ikke være i fortiden',
      },
      {
        type: 'confirmation',
        title: 'Bekreft leieforhold og dato',
        subtitle: 'Vennligst se over og bekreft sluttdato',
        summaryFields: [
          { key: 'action', label: 'Handling', value: 'Sett sluttdato og avslutt abonnement' },
          { key: 'reason', label: 'Begrunnelse', field: 'cancelReason' },
          { key: 'endDate', label: 'Sluttdato for leieforhold', field: 'selectedTenancyEndDate', format: 'date' },
        ],
        confirmationText: 'Ved å trykke på knappen under bekrefter du sluttdatoen.',
        actionMethod: 'onEndDateSubmit',
      },
      {
        type: 'success',
        title: 'Oppdatert',
        subtitle: 'Ny sluttdato er satt for dette leieforholdet',
        icon: 'budicon-check-circle',
        message: 'Sluttdato for leieforholdet med {tenantName} er oppdatert til {selectedTenancyEndDate}.',
        cancellationSummary: {
          title: 'Oppsummering:',
          reason: 'Begrunnelse: {reasonText}',
        },
      },
    ],
    terminate_only: [
      {
        type: 'subscription_selection',
        title: 'Velg nytt abonnement',
        subtitle: 'Hvilken abonnementsplan ønsker du å bytte til?',
        field: 'selectedNewSubscription',
      },
      {
        type: 'reason_selection',
        title: 'Hvorfor ønsker du å {changeActionType} abonnementet?',
        subtitle: 'Din tilbakemelding vil hjelpe oss å forbedre produktet.',
        condition: 'isDowngradeFlow',
        reasons: [
          { value: 'too_expensive', label: 'For dyrt' },
          { value: 'not_using_features', label: 'Bruker ikke nok features' },
          { value: 'found_better_alternative', label: 'Fant et bedre alternativ' },
          { value: 'business_closure', label: 'Bedriftsnedleggelse' },
          { value: 'no_longer_needed', label: 'Ikke lengre nødvendig' },
          { value: 'technical_issues', label: 'Tekniske problemer' },
          { value: 'poor_customer_service', label: 'Dårlig kundeservice' },
          { value: 'business_pause', label: 'Midlertidig bedrifts pause' },
          { value: 'other', label: 'Annen grunn', hasTextarea: true },
        ],
      },
      {
        type: 'confirmation',
        title: 'Bekreft {actionType}',
        subtitle: 'Vennligst bekreft at følgende informasjon er korrekt:',
        summaryFields: [
          { key: 'action', label: 'Handling', value: 'Endre abonnement' },
          { key: 'fromPlan', label: 'Fra', computed: 'getCurrentPlan', format: 'plan' },
          { key: 'toPlan', label: 'Til', field: 'selectedNewSubscription', format: 'plan' },
          {
            key: 'reason',
            label: 'Begrunnelse',
            field: 'cancelReason',
            condition: { field: 'isDowngradeFlow', operator: '!==', value: false },
          },
          { key: 'effective', label: 'Endring trer i kraft', computed: 'getEffectiveDate' },
        ],
        terminationNotice: {
          text: '{downgradeConfirmationNotice}{premiumInsuranceNotice}',
        },
        actionMethod: 'onCancelSubscriptionSubmit',
        actionText: '{confirmationAction}',
        buttonClass: 'btn btn-danger',
      },
      {
        type: 'success',
        title: 'Ditt abonnement er {changeType} til {selectedNewSubscription}',
        subtitle: {
          upgrade: 'Du kan begynne å bruke {selectedNewSubscription} funksjoner med en gang.',
          downgrade: '{downgradeSuccessSubtitle}',
        },
        disclaimer: {
          text: 'Endringene trer i kraft {effectiveDate}.',
          additionalText: '{downgradeAdditionalText}',
          additionalTextCondition: { field: 'isDowngradeFlow', operator: '!==', value: false },
        },
      },
    ],
    delete_tenancy: [
      {
        type: 'contact_support',
        title: 'Slett leieforhold',
        message: 'Kontakt kundeservice for slette leieforholdet på',
        phone: '22475800',
        email: 'support@husleie.no',
        actionMethod: 'closeModal',
        actionText: 'Lukk',
      },
    ],
  },
};
